import React from "react";
import { AlertTriangle, FileUp, X } from "lucide-react";
import Modal from "../shared/Modal";
import { Button } from "../../ds2/components";
import "./ModalCanvasUnsavedChanges.css";
import { ModalCanvasUnsavedChangesProps } from "./types";

export const ModalCanvasUnsavedChanges: React.FC<
  ModalCanvasUnsavedChangesProps
> = ({ isOpen, onSave, onDiscard, onCancel }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      style={{ width: "500px" }}
      canClose={false}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-canvas-unsaved-changes">
        <div className="modal-canvas-unsaved-changes-title">
          <div className="modal-canvas-unsaved-changes-icon">
            <AlertTriangle size={24} />
          </div>
          <h2>Keep your resource up to date</h2>
        </div>
        <div className="modal-canvas-unsaved-changes-body">
          <div className="modal-canvas-unsaved-changes-content">
            <div className="modal-canvas-unsaved-changes-label">
              You've made changes to this canvas and it is related to a resource
              in your knowledge base. Update the resource before closing or
              continue and don't update the resource.
            </div>
          </div>
        </div>
        <div className="modal-canvas-unsaved-changes-buttons">
          <Button
            variant="tertiary"
            onClick={onCancel}
            style={{ marginRight: "auto" }}
            autoFocus>
            Back
          </Button>

          <Button
            variant="tertiary"
            onClick={onDiscard}
            // leftIcon={<X size={16} />}
          >
            Continue
          </Button>

          <Button
            variant="primary"
            onClick={onSave}
            leftIcon={<FileUp size={16} />}>
            Save
          </Button>

          {/* <button
            className="modal-canvas-unsaved-changes-buttons-cancel"
            onClick={onCancel}
            autoFocus>
            Continue Editing
          </button>
          
          <button
            className="modal-canvas-unsaved-changes-button-danger"
            onClick={onDiscard}>
            Discard Changes
          </button>
          
          <button
            className="modal-canvas-unsaved-changes-button-primary"
            onClick={onSave}>
            <Save size={16} />
            Save & Close
          </button> */}
        </div>
      </div>
    </Modal>
  );
};
